import anime from 'animejs';

let isTop = true;
let isBig = true;

let isFold = false;
let isBg = false;
let isLogo = true;

const breakpoint = window.matchMedia( '(max-width:1312px)' );

let main = document.querySelector("main");

let linksWrap = document.getElementsByClassName("nav__links-wrap");
let slideBg = document.getElementsByClassName("nav__slide-bg");
let navbarBg = document.getElementsByClassName("nav__navbar-bg");

let navLogo = document.getElementsByClassName("nav__logo--img");
let navLogoTypo = document.getElementsByClassName("nav__logo--typo");

let burgerBtn = document.getElementById("burger-btn");
let backBtn = document.getElementById("back-btn");

let ani_multiplicator = 10;
let ani_time = 55 * ani_multiplicator;
let del_1 = 10 * ani_multiplicator;
let del_2 = 20 * ani_multiplicator;
let del_3 = 30 * ani_multiplicator;
let del_4 = 40 * ani_multiplicator;

// all animations
var linksShow;
var linksCollapse;
var logoTypoShow;
var logoTypoHide;
var logoHide;
var logoShow;
var navBgShow;
var navBgHide;
var closeNav;
var openNav;

// all waypoints
var topCheck;

// init all Anime.js animations
function addAnimations() {

	linksShow = anime.timeline({
		easing: 'easeInOutQuad',
		duration: del_3,
		autoplay: false,

		begin: function() {
			isFold = false;
		},
	});
				
	linksShow	
				.add({
					targets: burgerBtn,	
					translateY: [0, 20],
					opacity: [1,0],

					begin: function() {
						initLinks("collapse");
					},

					complete: function() {
						burgerBtn.style.display = 'none';
					},
				})			
				.add({
					targets: ".nav__link",
					delay: anime.stagger(25),
					
					translateY: [-20, 0],
					opacity: [0, 1],
				});


	linksCollapse = anime.timeline({
		easing: 'easeInOutQuad',
		duration: del_3,
		autoplay: false,

		begin: function() {
			isFold = true;
		},
	});

	linksCollapse	
				.add({
					targets: ".nav__link",
					delay: anime.stagger(25),
					
					translateY: [0, -20],
					opacity: [1,0],
				})
				.add({
					targets: burgerBtn,	
					translateY: [20,0],
					opacity: [0,1],
					
					begin: function() {
						burgerBtn.style.display = 'grid';
					},
					complete: function() {
						initLinks("slide");
					},
				},50);
			
	anime.set(burgerBtn, {
		translateY: 20,
		opacity: 0,
	});





	logoTypoShow = anime({
		easing: 'easeInOutQuart',
		duration: del_2,
		targets: navLogoTypo[0],
		autoplay: false,
		
		opacity: [0, 1],
		
		begin: function() {
			navLogoTypo[0].style.display = "block";
		},
	});	

	logoTypoHide = anime({
		easing: 'easeInOutQuart',
		duration: del_2,
		targets: navLogoTypo[0],
		autoplay: false,
		
		opacity: [1, 0],
		
		complete: function() {
			navLogoTypo[0].style.display = "none";
		},
	});	

	logoHide = anime({
		easing: 'easeInOutQuart',
		duration: del_2,
		targets: navLogo[0],
		autoplay: false,
		
		translateY: ["0%", "-50%"],
		opacity: [1, 0],
		
		begin: function() {
			isLogo = false;
		},
		
		complete: function() {
			navLogo[0].style.display = 'none';
			logoTypoShow.play();
		},
	});	

	logoShow = anime({
		easing: 'easeInOutQuart',
		duration: del_4,
		targets: navLogo[0],
		autoplay: false,

		translateY: ["-50%", "0%"],
		opacity: [0, 1],
		
		begin: function() {
			isLogo = true;
			navLogo[0].style.display = 'block';
			logoTypoHide.play();
		},
	});	

	anime.set(navLogo[0], {
		translateY: "0%",
		opacity: 1,
	});

	anime.set(navLogoTypo[0], {
		opacity: 0,
	});





	navBgShow = anime({
		easing: 'easeOutSine',
		duration: del_3,
		targets: navbarBg,
		translateY: ["-100%", 0],
		opacity: [0,1],
		autoplay: false,

		begin: function() {
			isBg = true;
		},
	});
				
	navBgHide = anime({
		easing: 'easeOutSine',
		duration: del_3,
		targets: navbarBg,
		translateY: [0, "-100%"],
		opacity: [1,0],
		autoplay: false,

		begin: function() {
			isBg = false;
		},

	});

	anime.set(navbarBg, {
		opacity: 0,
		translateY: "-100%",
	});





	closeNav = anime.timeline({
		easing: 'easeInOutQuad',
		duration: ani_time,
		autoplay: false,
		begin: function() {
			setScrolling(true);
		},
	});

	closeNav	
		.add({
			targets: main,
			translateX: [-50,0],
			duration: del_4,
		}, del_1)
		.add({
			targets: linksWrap,
			translateX: ["0%","100%"],
		}, 0)

		.add({
			targets: slideBg,
			opacity: [0.8,0],
			complete: function() {
				slideBg[0].style.display = "none";
			},
		}, 0)
				
		.add({
		targets: linksWrap,
		opacity: [1,0],
		duration: del_1,
	});

			



	openNav = anime.timeline({
		easing: 'easeOutQuart',
		duration: ani_time,
		autoplay: false,
		begin: function() {
			setScrolling(false);
		},
	});
	
	openNav	.add({
					targets: linksWrap,
					translateX: ["100","0%"],
				})

				.add({
					targets: main,
					translateX: [0,-50],
					duration: del_4,
				}, 0)
				
				.add({
					targets: linksWrap,
					opacity: [0,1],
					duration: del_1,
				}, 0)
				
				.add({
					targets: slideBg,
					opacity: [0,0.8],
					begin: function() {
						slideBg[0].style.display = "block";
					},
				}, 0)

				.add({
					targets: ".nav__link",
					delay: anime.stagger(100),
					translateX: [50,0],
					opacity: [0,1],
				}, del_1);

	anime.set(linksWrap, {
		opacity: 1,
		translateX: "0%",
	});

	anime.set(".nav__link", {
		opacity: 1,
		translateX: 0,
	});

	anime.set(slideBg, {
		opacity: 0,
		// translateX: 0,
	});
}

// init all waypoints
function addWaypoints() {
	topCheck = new Waypoint({
		element: document.querySelector("main"),
		handler: function(direction) {
			if(direction === "up") isTop = true;
			else if (direction === "down") isTop = false;
			breakpointCheck();
		},
		offset: "-32px",
	})
}

// helper function to en/disable scrolling if slider nav is open/closed
function setScrolling(scrolling){
	if(scrolling) document.body.style.overflow = 'unset';
	else document.body.style.overflow = 'hidden';
}

// initial link styles based on breakpoints and scroll position
function initloadLinks() {
	if(isBig) {
		if (isTop) {
			initLinks("normal");
		}
		else if (!isTop) {
			initLinks("collapse");
		}
	}

	else if(!isBig) {
		initLinks("slide");
	}
}

// helper function for initLoadLinks
function initLinks(mode) {
	console.log("mode: ",mode);
	
	slideBg[0].style.display = "none";

	if(mode === "collapse") {
		linksWrap[0].classList.remove("nav__links-wrap--slide");

		anime.set(linksWrap, {
			opacity: 1,
			translateX: 0,
		});

		anime.set(".nav__link", {
			opacity: 0,
			translateX: 0,
			translateY: 20,
		});
		
		anime.set(slideBg, {
			opacity: 0,
		});
		
	}
	else if(mode === "slide") {
		linksWrap[0].classList.add("nav__links-wrap--slide");

		anime.set(linksWrap, {
			opacity: 0,
			translateX: "100%",
		});

		anime.set(".nav__link", {
			opacity: 0,
			translateX: 50,
			translateY: 0,
		});
		
		anime.set(slideBg, {
			opacity: 0,
		});
	}
	else if(mode === "normal") {
		linksWrap[0].classList.remove("nav__links-wrap--slide");

		burgerBtn.style.display = 'none';

		anime.set(linksWrap, {
			opacity: 1,
			translateX: "0%",
		});

		anime.set(".nav__link", {
			opacity: 1,
			translateX: 0,
			translateY: 0,
		});
		
		anime.set(slideBg, {
			opacity: 0,
		});
	}
}

// set navbar on breakpoint/scroll eventlisteners
function setNavbar() {
	if(isBig) {
		if (isTop) {
			if(isFold) linksShow.play();
			if(!isLogo) logoShow.play();
			if(isBg) navBgHide.play();
		}
		else if (!isTop){
			if(!isFold) linksCollapse.play();
			if(isLogo) logoHide.play();
			if(!isBg) navBgShow.play();
		}
	}

	else if(!isBig) {
		if(!isFold) linksCollapse.play();
		
		if (isTop) {
			if(isBg) navBgHide.play();
			if(!isLogo) logoShow.play();
		}
		else if (!isTop){
			if(!isBg) navBgShow.play();
			if(isLogo) logoHide.play();
		}
	}
}

// break point eventlistener function
function breakpointCheck() {
	if ( breakpoint.matches === false) isBig = true;
	else if ( breakpoint.matches === true ) isBig = false;

	setNavbar();
}

// check breakpoiunt on pageload
function breakpointCheckInit() {
	if ( breakpoint.matches === false) isBig = true;
	else if ( breakpoint.matches === true ) isBig = false;
}

// add all eventlisteners
function addListeners() {
	breakpoint.addEventListener("change", breakpointCheck);
	
	burgerBtn.addEventListener("click", function() {
		console.log("Press Burger");
		openNav.play();
	});

	backBtn.addEventListener("click", function() {
		console.log("Press Close");
		closeNav.play();
	});

	slideBg[0].addEventListener("click", function() {
		console.log("Press Close");
		closeNav.play();
	});
}

export function initNav() {
	addAnimations();
	addWaypoints();
	addListeners();
	
	breakpointCheckInit();
	initloadLinks();
	setNavbar();
}

